<h3>Download GoArmy Edge {{ sport }}</h3>

<div class="button-area">
  <a *ngIf="sportLinkApple" angulartics2On="click" target="_blank"
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} iOS App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkApple }}"
     class="store apple">
     <img src="/assets/images/store-apple.svg" alt="">
  </a>
  <a *ngIf="sportLinkGoogle" angulartics2On="click" target="_blank"
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} Android App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkGoogle }}"
     class="store google">
     <img src="/assets/images/store-google.svg" alt="">
  </a>
  <a *ngIf="sportLinkWindows" angulartics2On="click" target="_blank"
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} Windows App"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkWindows }}"
     class="store microsoft">
     <img src="/assets/images/store-windows.svg" alt="">
  </a>
  <a *ngIf="sportLinkWebgl" angulartics2On="click" 
  angularticsCategory="Download"
     angularticsLabel="{{ sport }} WebGL"
     [angularticsProperties]="{ label: 'Click from ' + sport + ' page' }"
     href="{{ sportLinkWebgl }}"
     target="_blank"
     class="store webplayer">
     <img src="/assets/images/web-player.svg" alt="">
  </a>
</div>